import React from "react";
import { Card } from "./Card.styled";
import { BodyText } from "../text/BodyText.styled";
import { ediphiPalette } from "../../styles/colors";

interface EmptyStateProps {
  text: string;
}

const EmptyStateCard: React.FC<EmptyStateProps> = ({ text }) => {
  return (
    <Card
      sx={{
        border: `1px dashed ${ediphiPalette.borderStrong}`,
        justifyContent: "center",
        textAlign: "center",
        background: ediphiPalette.surfaceSubtle,
      }}
    >
      <BodyText>{text}</BodyText>
    </Card>
  );
};

export default EmptyStateCard;
